import React from 'react';
import { Box, List, ListItemButton, ListItemText } from '@mui/material';
import { sections } from '.'; // mantém como estava



export default function Sidebar({
  selectedIndex,
  onSelect,
  drawerWidth,
  inDrawer = true, // no AppDocs usamos sempre dentro de Drawer
}) {
  return (
    <Box
      className="sidebar-root"
      sx={
        inDrawer
          ? {
              // dentro do Drawer: ocupa todo o papel do Drawer
              position: 'relative',
              width: '100%',
              height: '100%',
              overflowY: 'auto',
              p: 2,
            }
          : {
              // fallback se um dia usar fora de Drawer
              position: 'fixed',
              top: 0,
              left: 0,
              width: drawerWidth,
              height: '100vh',
              overflowY: 'auto',
              p: 2,
            }
      }
    >
      <List dense>
        {sections.map((sec, idx) => (
          <ListItemButton
            key={sec.title}
            selected={selectedIndex === idx}
            onClick={() => onSelect(idx)}
            sx={{ px: 2 }}
          >
            <ListItemText primary={sec.title} />
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
}
